import script from "./expertNotes.vue?vue&type=script&setup=true&lang=js"
export * from "./expertNotes.vue?vue&type=script&setup=true&lang=js"

import "./expertNotes.vue?vue&type=style&index=0&id=b101c38a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b101c38a"]])

export default __exports__